class AcessibilityDisplayControll {

    constructor(_window, _document, _acessibilityConfig) {
        this.window = _window;
        this.document = _document
        this.acessibilityConfig = _acessibilityConfig;
    }
        
    
    init(){
        var autoStyle = "";
        var ua = this.window.navigator.userAgent;
        var msie = ua.indexOf("MSIE ");

        if(this.acessibilityConfig.tools == false || msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)){
            autoStyle += `
                ._access-icon{
                    display:none!important;
                }

                .acessibility_controll{
                    display:none!important;
                }
            `;

            
        }else{

            var acessibility_elements = this.document.getElementsByClassName("acessibility_controll");
            var acess_root_el = this.document.getElementsByClassName("_access-icon");
       
            setTimeout(() => { 
                
                if(acessibility_elements.length > 0 && acess_root_el.length > 0){
                    for(var n=0; n<acessibility_elements.length;n++){
                        var acess_el = acessibility_elements[n];
                        acess_el.addEventListener("click", function () {
                            acess_root_el[0].click();
                        });
                    }
                }else if(acess_root_el.length > 0 && acessibility_elements.length == 0){
                    acess_root_el[0].style.visibility = "visible";
                }

                
             }, 4000);

        }

       

        if(!this.acessibilityConfig.outlines){
            autoStyle += `
                *{
                    outline:none!important;
                }
            `;
        }

        this.document.head.appendChild(Object.assign(this.document.createElement("style"), {textContent: autoStyle}));
     
    }
    
}
